<template>
  <v-container fill-height>
    <v-row>
      <v-col align="center">
        <img class="logo" src="images/FOXLOGO_WEB_White_Small.png" alt="Fox Sports">
        <v-btn
          v-if="!authenticated"
          color="white"
          class="login-button"
          @click="login"
        >
          Login with Okta
        </v-btn>
        
        <div v-if="authenticated" class="load-indicator">
          <v-progress-circular size="40" indeterminate color="white" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {

    }
  },

  computed: {
    authenticated () {
      return this.$store.state.authenticated
    }
  },

  methods: {
    login () {
      const targetPage = this.$route.query.target || 'stories'
      console.log(`Logging into target page: ${targetPage}`)
      this.$auth.loginRedirect(`/${targetPage}`)
    }
  },

  mounted () {    
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

body {
  background-color: $brand-dark;
}

.container {
  text-align: center;
}
.logo {
  display: block;
  height: 160px;
  margin-bottom: $space-ms;
  @include media($bp-tablet) {
    height: 130px;
    margin-bottom: 22px;
  }
}

.login-button.v-btn {
  font-family: $font-display;
  font-size: $font-size-s;
  @include media($bp-tablet) {
    font-size: $font-size-xs;
    height: 34px !important;
  }
}
</style>